import { render, staticRenderFns } from "./form-action-buttons-group.vue?vue&type=template&id=04942ea4&"
import script from "./form-action-buttons-group.vue?vue&type=script&lang=js&"
export * from "./form-action-buttons-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04942ea4')) {
      api.createRecord('04942ea4', component.options)
    } else {
      api.reload('04942ea4', component.options)
    }
    module.hot.accept("./form-action-buttons-group.vue?vue&type=template&id=04942ea4&", function () {
      api.rerender('04942ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-action-buttons-group.vue"
export default component.exports